import React from 'react';
import {Navbar, NavbarBrand, NavbarContent, NavbarItem} from "@nextui-org/navbar";
import {Image} from "@nextui-org/react";
import {Button} from "@nextui-org/react";
import brandLogo from '../src/assets/images/icon128.png'
const Navigation = () => {

    function redirectToUrl(url) {
        if (url) {
            window.location.href = url;
        } else {
            console.error('Invalid URL');
        }
    }

    function openUrlInNewTab(url) {
        if (url) {
            window.open(url, '_blank');
        } else {
            console.error('Invalid URL');
        }
    }
    return (
        <Navbar>
            <NavbarBrand className="flex gap-2">
                <Image
                    isBlurred
                    width={20}
                    src={brandLogo}
                    alt="Brand Logo "
                    onClick={() => redirectToUrl('https://vortexiai.netlify.app')}
                />
                <p className="font-bold text-inherit">Vortexi</p> <span className=" font-montserrat-semibold">Beta</span>
            </NavbarBrand>
            <NavbarContent className="hidden sm:flex gap-4" justify="center">
            </NavbarContent>
            <NavbarContent justify="end">
                <NavbarItem>
                    <Button className="rounded-full" color="primary" variant="solid"
                        onClick={() => openUrlInNewTab('https://chromewebstore.google.com/detail/vortexi/chagdghinejpldgfbkjhnalpaajaifbo')}>
                        Download
                    </Button>
                </NavbarItem>
            </NavbarContent>
        </Navbar>
    );
}

export default Navigation;
